/** 展示loading */
export function showLoading(message?: string, { forbidClick = true } = {}) {
  showLoadingToast({
    message: message || '',
    duration: 0,
    forbidClick
  })
}

/** 关闭loading */
export function hideLoading() {
  closeToast()
}

/** 展示toast */
export function showToastMessage(message: string, { duration = 2500 } = {}) {
  // 文案较长时使用confirm展示
  if (message?.length > 16) {
    showDialog({
      title: message,
      theme: 'round-button',
      confirmButtonText: '知道了'
    })
    return
  }
  message &&
    showToast({
      message,
      duration
    })
}

/** 展示Dialog */
export function showConfirm({
  title,
  content,
  okBtnTxt,
  cancelBtnTxt,
  okCbFun,
  messageAlign,
  cancelCbFun
} = {}) {
  // 定义一个对象params，包含对话框的标题、内容、确认按钮文本和取消按钮文本
  const params: Record<string, any> = {
    title, // 对话框标题
    message: content || '', // 对话框内容，默认为空字符串
    confirmButtonText: okBtnTxt, // 确认按钮文本
    cancelButtonText: cancelBtnTxt // 取消按钮文本
  }
  if (messageAlign) {
    params.messageAlign = messageAlign
  }
  // 调用showDialog函数显示对话框，传入主题和按钮配置
  showDialog({
    allowHtml: true,
    theme: 'round-button', // 对话框主题
    showCancelButton: !!cancelBtnTxt, // 根据cancelBtnTxt是否存在决定是否显示取消按钮
    ...params // 展开params对象，传入对话框的配置参数
  })
    .then(() => {
      // 对话框确认后的处理逻辑
      if (typeof okCbFun === 'function') {
        okCbFun() // 如果okCbFun是函数类型，则调用该函数
      }
    })
    .catch(() => {
      // 对话框取消或关闭后的处理逻辑
      if (typeof cancelCbFun === 'function') {
        cancelCbFun() // 如果cancelCbFun是函数类型，则调用该函数
      }
    })
}

/** 隐藏Dialog */
export function hideConfirm() {
  closeDialog()
}
